var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle2, _circle3, _path, _rect7, _rect8, _rect9, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 99,
    viewBox: "0 0 162 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 49.5,
    r: 49.5,
    fill: "#F0F0F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 124,
    height: 18,
    rx: 9,
    fill: "#F0F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 108,
    height: 18,
    rx: 9,
    fill: "#F0F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 65,
    width: 127,
    height: 18,
    rx: 9,
    fill: "#F0F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 18,
    rx: 9,
    fill: "#F0F0F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 65,
    width: 109,
    height: 18,
    rx: 9,
    fill: "#F0F0F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 81,
    width: 129,
    height: 18,
    rx: 9,
    fill: "#F0F0F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 39,
    r: 22,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 39,
    r: 23.5,
    stroke: "#111111",
    strokeOpacity: 0.6,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 40C54 29.5066 62.5066 21 73 21",
    stroke: "#111111",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7066,
    y: 59.432,
    width: 4,
    height: 23,
    transform: "rotate(-42.9124 86.7066 59.432)",
    fill: "white",
    fillOpacity: 0.6,
    stroke: "#707070"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7066,
    y: 64.4711,
    width: 7,
    height: 23,
    rx: 0.5,
    transform: "rotate(-42.9124 89.7066 64.4711)",
    fill: "#707070",
    stroke: "#707070"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3636,
    y: 62.6289,
    width: 0.758535,
    height: 18.3947,
    rx: 0.379268,
    transform: "rotate(-42.9124 95.3636 62.6289)",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.758535
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5714 89L51 91.087L49.4286 89H48.1429L50.3857 91.9087L48 95H49.2857L51 92.7304L52.7143 95H54L51.6143 91.9087L53.8571 89H52.5714Z",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 29L11 31.087L9.42857 29H8.14286L10.3857 31.9087L8 35H9.28571L11 32.7304L12.7143 35H14L11.6143 31.9087L13.8571 29H12.5714Z",
    fill: "#707070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107 34.36C107 35.004 107.145 35.5827 107.434 36.096C107.733 36.6 108.134 36.9967 108.638 37.286C109.142 37.5753 109.707 37.72 110.332 37.72C110.967 37.72 111.531 37.5753 112.026 37.286C112.53 36.9967 112.927 36.6 113.216 36.096C113.515 35.5827 113.664 35.004 113.664 34.36C113.664 33.7067 113.515 33.128 113.216 32.624C112.927 32.12 112.53 31.7233 112.026 31.434C111.531 31.1447 110.967 31 110.332 31C109.707 31 109.142 31.1447 108.638 31.434C108.134 31.7233 107.733 32.12 107.434 32.624C107.145 33.128 107 33.7067 107 34.36ZM108.134 34.36C108.134 33.912 108.227 33.5153 108.414 33.17C108.61 32.8153 108.871 32.54 109.198 32.344C109.534 32.148 109.912 32.05 110.332 32.05C110.752 32.05 111.125 32.148 111.452 32.344C111.788 32.54 112.049 32.8153 112.236 33.17C112.432 33.5153 112.53 33.912 112.53 34.36C112.53 34.808 112.432 35.2047 112.236 35.55C112.049 35.8953 111.788 36.1707 111.452 36.376C111.125 36.572 110.752 36.67 110.332 36.67C109.912 36.67 109.534 36.572 109.198 36.376C108.871 36.1707 108.61 35.8953 108.414 35.55C108.227 35.2047 108.134 34.808 108.134 34.36Z",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7c8469f6107eeb9ec2b95b41f763bd22.svg";
export { ForwardRef as ReactComponent };